import type { BillingModelType } from '../../types/pool';
import { BillingModelTypeDisplay } from '../../types/pool';

interface PoolBillingBadgeProps {
  billingModelType: BillingModelType;
}

const PoolBillingBadge = ({ billingModelType }: PoolBillingBadgeProps) => {
  const styleByType: Record<BillingModelType, string> = {
    'all-inclusive': 'bg-cloud text-primary',
    'pay-per-visit': 'bg-warningLight text-warning',
  };

  return (
    <span
      className={`inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded-lg whitespace-nowrap ${styleByType[billingModelType]}`}
    >
      {BillingModelTypeDisplay[billingModelType]}
    </span>
  );
};

export default PoolBillingBadge;
